module.exports = __webpack_public_path__ + "af8d3518aa6a1cc22cd731b88c569b15.png";